import React from 'react';
import PropTypes from 'prop-types';
import AppNotification from 'Components/AppNotification/AppNotification.jsx';
import './QueueView.scss';

const QueueView = (props) => {
  return (
    <div className="Queueview">
      <div
        className={props.isBorder ? "listview view-last-border" : "listview"}
        key={props.id}
      >
        <div role="button" className="link-wrapper">
          <div className="left-side-listview">
            <span
              className="cursor-view"
              onKeyDown={() => props.onViewClick(props.id)}
              onClick={() => props.onViewClick(props.id)}
            >
              {props.name}
              <AppNotification
                className="app-notification-badge"
                info
                badgeType="info"
              >
                {props.count}
              </AppNotification>
            </span>
          </div>
          <div className="right-side-listview">
            <button type="button" className="hollow-button-view" onClick={() => props.onViewClick(props.id)}>
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

QueueView.propTypes = {
  extraClass: PropTypes.string,
  onViewClick: PropTypes.func,
  name: PropTypes.string,
  count: PropTypes.number,
  isBorder: PropTypes.bool,
};

QueueView.defaultProps = {
  extraClass: '',
  onViewClick: () => { },
  isBorder: false
};

export default QueueView;
